<title>{{ apiReferenceErrorResponsePage.htmlTitle }}</title>
<app-api-reference-table-section [tableSections]="apiReferenceErrorResponsePage.tableSections" [apiReferenceErrorResponsePage]="true" [isDefault]="false"></app-api-reference-table-section>
